
export const ApplicationTitleConfig = {

  extremeweather: {
  	windspeed :{
   	  title : 'Wind Speed Forecast',
   	  processedTime : true
  	},
  	rainfall : {
  		title : 'Rainfall',
  		processedTime : true
  	},
  	temperature : {
  		title : 'Temperature Forecast',
  		processedTime : true
  	},
  	humidity : {
  		title : 'Humidity Forecast',
  		processedTime : true
  	},
	  'rainfall-actual' : {
		title : 'Actual Weather - Rainfall'
	},
	'windspeed-actual' : {
		title : 'Actual Weather - Wind Speed'
	},
	'temperature-actual' : {
		title : 'Acutal Weather - Temperature'
	},
	'humidity-actual' : {
		title : 'Actual Weather - Humidity'
	}
  },
  observedweather : {
  	'rainfall-actual' : {
  		title : 'Observed Weather - Rainfall'
  	},
  	'windspeed-actual' : {
  		title : 'Observed Weather - Wind Speed'
  	},
  	'temperature-actual' : {
  		title : 'Observed Weather - Temperature'
  	},
  	'humidity-actual' : {
  		title : 'Observed Weather - Humidity'
  	}
  },
  heatwatches : {
  	heatwatches : {
  		title : 'Heat Watch Forecast'
  	},
  	heatindex : {
  		title : 'Heat Index Forecast'
  	},
  	heatwave : {
  		title : 'Heat Wave Forecast'
    },
    discomfortIndex : {
      title : 'Discomfort Index'
    }
  },
  drinkingwaterstress : {
  	gis : {
  		title : 'Drinking Water Stress'
  	}
  },
  nowcastweather : {
  	districtwarnings : {
  		title : 'District Warnings'
  	},
  	stationwarnings : {
  		title : 'Station Warnings'
  	},
  	cloudcover : {
  		title : 'Cloud Cover'
  	},
  	cloudtemperature : {
  		title : 'Cloud Top Temperature'
  	},
  	radar : {
  		title : 'Radar'
  	}
  },
  cyclone : {
  	'cyclone forecast' : {
		title : 'RADAR+CTT',
		processedTime : true
  	},
  	'wave height' : {
  		title : 'MLP Predicted'
  	},
  	'cloud top temperature' : {
  		title : 'EUMETSAT Precipitation Rate'
  	},
  	'cloud cover' : {
  		title : 'Cloud Top Temperature'
  	},
  	'radar' : {
  		title : 'Radar'
  	}
  },
  drought : {
  	gis : {
  		title : 'Drought Dashboard'
  	}
  },
  floodforecast : {
  	gis : {
  		title : 'Nowcast Flood Alerts'
  	}
  }

};


// export interface IApplicationTitle {
//   title?: string;
//   formatter ?: string;
// }
